const GRANULARITIES = [
  { id: 'day', label: 'По дням' },
  { id: 'week', label: 'По неделям' },
  { id: 'month', label: 'По месяцам' }
];

export const SELECT_CLASS = 'h-9 max-w-full rounded-lg border bg-background px-2 text-sm text-foreground';

export const GranularitySelect = ({ value, onChange, label, trackId }) => (
  <select
    data-ev={trackId}
    data-ev-send-value
    aria-label={label}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    className={SELECT_CLASS}
  >
    {GRANULARITIES.map(({ id, label: optionLabel }) => (
      <option key={id} value={id}>
        {optionLabel}
      </option>
    ))}
  </select>
);

/** Переключатель показателя графика: значения — перечисление из кода, поэтому уходят в метрики. */
export const MetricToggle = ({ options, value, onChange, trackId }) => (
  <div className="flex rounded-lg border p-0.5 text-sm">
    {options.map(({ id, label }) => (
      <button
        key={id}
        type="button"
        data-ev={trackId}
        data-ev-value={id}
        aria-pressed={value === id}
        onClick={() => onChange(id)}
        className={value === id ? 'rounded-md bg-muted px-2 py-1 font-medium' : 'rounded-md px-2 py-1 text-muted-foreground'}
      >
        {label}
      </button>
    ))}
  </div>
);

export const ErrorText = ({ children }) => <p className="mt-5 text-sm text-red-700 dark:text-red-400">{children}</p>;

export const MutedText = ({ children }) => <p className="mt-5 text-sm text-muted-foreground">{children}</p>;
